import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { Activity, User, Tag, Filter } from "lucide-react";

const TYPE_COLORS = {
  customer: "text-blue-400 bg-blue-500/10 border-blue-500/20",
  insurance: "text-cyan-400 bg-cyan-500/10 border-cyan-500/20",
  body_shop: "text-emerald-400 bg-emerald-500/10 border-emerald-500/20",
  technician: "text-amber-400 bg-amber-500/10 border-amber-500/20",
  vendor: "text-purple-400 bg-purple-500/10 border-purple-500/20",
  rate_table: "text-pink-400 bg-pink-500/10 border-pink-500/20",
};
const ACTION_COLORS = {
  created: "text-emerald-400",
  updated: "text-amber-400",
  archived: "text-red-400",
  import: "text-blue-400",
};

export default function ActivityLogs() {
  const [logs, setLogs] = useState([]);
  const [typeFilter, setTypeFilter] = useState("");

  useEffect(() => {
    const q = typeFilter ? `?entity_type=${typeFilter}` : "";
    api.get(`/master/activity${q}`).then((r) => setLogs(r.data));
  }, [typeFilter]);

  return (
    <div className="space-y-6 animate-slide-up" data-testid="activity-logs-page">
      <div className="flex items-start gap-4">
        <div className="w-12 h-12 rounded-xl bg-blue-600/15 border border-blue-500/20 flex items-center justify-center">
          <Activity className="w-6 h-6 text-blue-400" />
        </div>
        <div>
          <div className="text-xs uppercase tracking-[0.22em] text-slate-500 font-bold mb-1">Admin</div>
          <h1 className="font-display text-3xl font-semibold tracking-tight">Activity Logs</h1>
          <p className="text-sm text-slate-400 mt-1">Audit trail of every Master Data create, update, archive & import.</p>
        </div>
      </div>

      <div className="flex gap-2 items-center">
        <Filter className="w-4 h-4 text-slate-500" />
        {["", "customer", "insurance", "body_shop", "technician", "vendor", "rate_table"].map((t) => (
          <button
            key={t || "all"}
            data-testid={`filter-${t || "all"}`}
            onClick={() => setTypeFilter(t)}
            className={`text-[10px] uppercase tracking-wide font-bold px-2.5 py-1.5 rounded-lg border transition-colors ${
              typeFilter === t ? "bg-blue-600/20 text-blue-300 border-blue-500/40" : "bg-slate-900/40 text-slate-400 border-slate-800 hover:border-slate-700"
            }`}
          >{t ? t.replace("_", " ") : "All"}</button>
        ))}
      </div>

      <div className="rounded-xl border border-slate-800 bg-[#0B1120] overflow-hidden">
        {logs.length === 0 ? (
          <div className="text-center text-slate-500 py-12 text-sm">No activity yet</div>
        ) : (
          <div className="divide-y divide-slate-800/60">
            {logs.map((l) => {
              const tc = TYPE_COLORS[l.entity_type] || "text-slate-400 bg-slate-800/20 border-slate-700";
              return (
                <div key={l.id} data-testid={`log-${l.id}`} className="px-5 py-3 flex items-center gap-4 hover:bg-slate-900/30 transition-colors">
                  <div className={`text-[10px] uppercase tracking-wide font-bold px-2 py-1 rounded border ${tc}`}>{l.entity_type.replace("_", " ")}</div>
                  <div className={`text-xs font-bold uppercase tracking-wide ${ACTION_COLORS[l.action] || "text-slate-400"}`}>{l.action}</div>
                  <div className="flex-1 text-sm text-slate-300 font-mono text-xs truncate">{l.entity_id}</div>
                  <div className="flex items-center gap-1.5 text-xs text-slate-500"><User className="w-3 h-3" />{l.actor_name}</div>
                  <div className="text-[10px] font-mono text-slate-600 w-40 text-right">{new Date(l.at).toLocaleString()}</div>
                </div>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
}
